import infratekhneLogo from "@/assets/logos/infratekhne.svg";
import ignitialLogo from "@/assets/logos/ignitial.png";
import nienteLogo from "@/assets/logos/niente-da-dire.png";

const COMPANIES = [
  { name: "InfraTekhne", logo: infratekhneLogo, href: "https://infratekhne.com" },
  { name: "Ignitial", logo: ignitialLogo, href: "https://ignitial.io" },
  { name: "Niente da dire", logo: nienteLogo, href: "https://nientedadire.com" },
];

export function SocialProof() {
  return (
    <section className="mx-auto max-w-6xl px-6 py-16">
      <p className="text-center text-xs font-bold uppercase tracking-[0.16em] text-muted-foreground">
        Trusted by engineering teams
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
        {COMPANIES.map(({ name, logo, href }) => (
          <a
            key={name}
            href={href}
            target="_blank"
            rel="noreferrer"
            className="group flex items-center gap-2.5 text-foreground/35 transition-colors hover:text-foreground/70"
          >
            <img
              src={logo}
              alt=""
              aria-hidden="true"
              className="h-6 w-auto opacity-60 transition-opacity group-hover:opacity-100"
            />
            <span className="text-base font-extrabold tracking-tight">{name}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
